import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMemo, useRef } from 'react';
import { BehaviorSubject } from 'rxjs';
import { ListConductorNavigationProvider, ListConductorQueryParams } from './navigation-provider';

export function useListConductorNavigationProvider(): ListConductorNavigationProvider {
  const reactRouterNavigate = useNavigate();
  const [params] = useSearchParams();

  const onQueryParamsChangeRef = useRef(new BehaviorSubject({}));
  const onQueryParamsChange$ = onQueryParamsChangeRef.current.asObservable();

  const queryParams = useMemo(() => {
    const _queryParams = [...params.entries()].reduce((acc, [key, val]) => {
      return {
        ...acc,
        [key]: val
      };
    }, {});

    onQueryParamsChangeRef.current.next(_queryParams);

    return _queryParams;
  }, [params]);

  const navigate = (queryParamsToUpdate: ListConductorQueryParams) => {
    reactRouterNavigate(
      {
        search: new URLSearchParams({
          ...queryParams,
          ...queryParamsToUpdate
        }).toString()
      },
      {
        replace: true
      }
    );
  };

  return {
    navigate,
    onQueryParamsChange$
  };
}
